import strings from '../../Localization/Localization';

import React from 'react';
import { OverlayTrigger, Tooltip } from 'react-bootstrap';

import {
  phoneIndex as index,
  phoneExportData as exportData
} from '../../API/Services';
import { phoneForm as searchForm } from '../Form/Search/services';

import { services as routes } from '../Route/routes';

export const conf = {
  index: {
    pageTitle: strings.common.homepage.phoneServices,

    id: "phoneService",
    api: index,
    onClickItem: {
      redirect: true,
      path: (id) => routes.routes.show.createPath(id)
    },

    export: {
      link: (search) => exportData(search),
      auth: ['ROLE_PHONE_SERVICE_EXTRACT']
    },

    searchForm: searchForm,
    computeSearch: (search) => {
      let result = {};
      if(search.serialNumber) {
        result["serial_number"] = search.serialNumber;
      }
      if(search.orderNumber) {
        result["order_number"] = search.orderNumber;
      }
      if(search.quoteNumber) {
        result["quote_number"] = search.quoteNumber;
      }
      if(search.productName) {
        result["product_name"] = search.productName;
      }
      if(typeof search.partner === 'object') {
        result["partner_id"] = search.partner.id
      }
      if(typeof search.client === 'object') {
        result["client_id"] = search.client.id
      }
      if(typeof search.place === 'object') {
        result["place_id"] = search.place.id
      }
      if(search.emptyApiKey) {
        result["empty_api_key"] = search.emptyApiKey;
      }
      if(search.consumptionDate) {
        result["consumption_date"] = search.consumptionDate;
      }

      if(typeof search.productSubFamily === 'object') {
        result["product_sub_family_id"] = search.productSubFamily.id
      }

      let technicalDataKeys = [];
      let technicalDataValues = [];
      if(typeof search.technicalDatas === 'object') {
        const regex = /.+_(\d+)/;
        Object.keys(search.technicalDatas).forEach((technicalDataKey, i) => {
          if(search.technicalDatas[technicalDataKey]) {
            let result = regex.exec(technicalDataKey);
            technicalDataKeys.push(result[1]);
            technicalDataValues.push(search.technicalDatas[technicalDataKey]);
          }
        });
      }
      if(technicalDataKeys.length > 0 && technicalDataValues.length > 0) {
        result["technical_data_keys"] = technicalDataKeys.join(",");
        result["technical_data_values"] = technicalDataValues.join(",");
      }

      return result;
    },
    computeSearchForDisplay: (search) => {
      let result = Object.assign({}, search);
      if (result.technicalDatas) Object.keys(result.technicalDatas).forEach((key) => {
        result["td_"+key] = result.technicalDatas[key];
      });
      result.technicalDatas = undefined;

      return result;
    },
    computeSearchCustomLabelsForDisplay: (search) => {
      let result = {}
      const regex = /td_(.+)_\d+/;
      if (search) Object.keys(search).forEach((key) => {
        if(key.startsWith("td_")) {
          let regexResult = regex.exec(key);
          result[key] = "DT "+regexResult[1];
        }
      });
      return result;
    },

    availableItemDisplay:['tab'],
    itemDisplay: {
      tab: {
        enableHeaderEdit: true,
        defaultHeader: [0,5,6,9,10,11,12,13,14,15],
        indexScheme: "index_phone",
        headers: [
          {
            id: "state",
            label: <>&nbsp;&nbsp;<i className="icon-flag-1"/>&nbsp;&nbsp;</>,
            value: item => {
              switch (item['state']) {
                case 'active':
                  return (
                    <OverlayTrigger
                      placement="right"
                      overlay={
                        <Tooltip>{strings.form.service.state.options.active}</Tooltip>
                      }>
                      <div className="item-index-status item-index-status-normal item-index-status-rounded item-index-status-info"/>
                    </OverlayTrigger>
                  );
                case 'inactive':
                  return (
                    <OverlayTrigger
                      placement="right"
                      overlay={
                        <Tooltip>{strings.form.service.state.options.inactive}</Tooltip>
                      }>
                      <div className="item-index-status item-index-status-normal item-index-status-rounded item-index-status-danger"/>
                    </OverlayTrigger>
                  );
                case 'termination':
                  return (
                    <OverlayTrigger
                      placement="right"
                      overlay={
                        <Tooltip>{strings.form.service.state.options.termination}</Tooltip>
                      }>
                      <div className="item-index-status item-index-status-normal item-index-status-rounded item-index-status-warning"/>
                    </OverlayTrigger>
                  );
                case 'termination_waiting':
                  return (
                    <OverlayTrigger
                      placement="right"
                      overlay={
                        <Tooltip>{strings.form.service.state.options.terminationWaiting}</Tooltip>
                      }>
                      <div className="item-index-status item-index-status-normal item-index-status-rounded item-index-status-warning"/>
                    </OverlayTrigger>
                  );
                case 'termination_scheduled':
                  return (
                    <OverlayTrigger
                      placement="right"
                      overlay={
                        <Tooltip>{strings.form.service.state.options.terminationScheduled}</Tooltip>
                      }>
                      <div className="item-index-status item-index-status-normal item-index-status-rounded item-index-status-warning"/>
                    </OverlayTrigger>
                  );
                case 'terminated':
                  return (
                    <OverlayTrigger
                      placement="right"
                      overlay={
                        <Tooltip>{strings.form.service.state.options.terminated}</Tooltip>
                      }>
                      <div className="item-index-status item-index-status-normal item-index-status-rounded item-index-status-danger"/>
                    </OverlayTrigger>
                  );
                default:
                  return item['state'];
              }

            }
          },
          {
            id: "order",
            label: "Commande",
            value: item => item["order"]?item["order"]["number"]:""
          },
          {
            id: "partner",
            label: "Partenaire",
            value: item => item["client"]["partner"]["name"]
          },
          {
            id: "place",
            label: "Site",
            value: item => item["place"]["name"]
          },
          {
            id: "product",
            label: "Produit",
            value: item => {
              if(item["cart_item"]["product"]["name"] && item["cart_item"]["product"]["name"].length > 15) {
                return (
                  <OverlayTrigger
                    placement="right"
                    overlay={
                      <Tooltip>{item["cart_item"]["product"]["name"]}</Tooltip>
                    }>
                    <div>{item["cart_item"]["product"]["name"].substring(0, 12)+"..."}</div>
                  </OverlayTrigger>
                );
              }
              return item["cart_item"]["product"]["name"];
            }
          },
          {
            id: "number",
            label: "Numéro",
            value: "serial_number"
          },
          {
            id: "name",
            label: "Nom",
            value: (item) => {
              const acceptableFirstnameTechnicalDataCodingValue = ["firstname"];
              let firstname = "";
              const acceptableLastnameTechnicalDataCodingValue = ["lastname"];
              let lastname = "";

              //check in main service
              if(item["technical_data_values"]) {
                item["technical_data_values"].forEach((technicalDataValue) => {
                  if(technicalDataValue["value"] && acceptableFirstnameTechnicalDataCodingValue.includes(technicalDataValue["technical_data"]["coding_value"])) {
                    firstname = technicalDataValue["value"]
                  }
                  if(technicalDataValue["value"] && acceptableLastnameTechnicalDataCodingValue.includes(technicalDataValue["technical_data"]["coding_value"])) {
                    lastname = technicalDataValue["value"]
                  }
                });
              }

              return `${firstname} ${lastname}`
            }
          },
          {
            id: "sim",
            label: "N° SIM",
            value: (item) => {
              const acceptableSimTechnicalDataCodingValue = ["sim_number"];
              let sim = "";

              //check in main service
              if(item["technical_data_values"]) {
                item["technical_data_values"].forEach((technicalDataValue) => {
                  if(technicalDataValue["value"] && acceptableSimTechnicalDataCodingValue.includes(technicalDataValue["technical_data"]["coding_value"])) {
                    sim = technicalDataValue["value"]
                  }
                });
              }

              return `${sim}`
            }
          },
          {
            id: "puk",
            label: "Code PUK",
            value: (item) => {
              const acceptablePukTechnicalDataCodingValue = ["puk_code"];
              let puk = "";

              //check in main service
              if(item["technical_data_values"]) {
                item["technical_data_values"].forEach((technicalDataValue) => {
                  if(technicalDataValue["value"] && acceptablePukTechnicalDataCodingValue.includes(technicalDataValue["technical_data"]["coding_value"])) {
                    puk = technicalDataValue["value"]
                  }
                });
              }

              return `${puk}`
            }
          },
          {
            id: "totalNumberOfDestination",
            label: "Qté appel inclus",
            value: (item) => {
              let quantityUsed = item["phone_package_order"]["monthly_consumption"]["total_number_of_destination"];
              if(quantityUsed === undefined) {
                quantityUsed = '-';
              }
              //TODO need multiply service quantity
              let quantityTotal = item["quantity"] * item["phone_package_order"]["phone_package_product"]["canal_quantity"] * item["phone_package_order"]["phone_package_product"]["phone_package"]["included_specific_phone_number"]
              if(quantityTotal === 0) {
                return '-';
              }
              return `${quantityUsed} / ${quantityTotal}`
            }
          },
          {
            id: "dataQuantity",
            label: "Qté donn. (Go)",
            value: (item) => {
              let dataQuantityUsed = item["phone_package_order"]["monthly_consumption"]["included_total_data_quantity_used"];
              if(dataQuantityUsed === undefined) {
                dataQuantityUsed = '-';
              }
              else {
                dataQuantityUsed = Math.round(dataQuantityUsed/1024/1024 *100)/100;
              }
              let dataQuantity = item["phone_package_order"]["phone_package_product"]["phone_package"]["included_total_data_quantity"];
              if(dataQuantity === undefined || dataQuantity === 0) {
                return '-';
              }
              dataQuantity = Math.round(dataQuantity/1024/1024 *100)/100
              return `${dataQuantityUsed} / ${dataQuantity}`;
            }
          },
          {
            id: "phoneTime",
            label: "Tps. appel inclus",
            value: (item) => {
              let phoneTimeUsed = item["phone_package_order"]["monthly_consumption"]["included_total_phone_time_used"];
              let phoneTimeUsedHour = "";
              let phoneTimeUsedMinute = "";
              // let phoneTimeUsedSecond = "";
              if(phoneTimeUsed === undefined) {
                return '-';
              }
              else {
                phoneTimeUsedHour = Math.floor(phoneTimeUsed / 3600);
                phoneTimeUsedMinute = String(Math.floor((phoneTimeUsed - phoneTimeUsedHour * 3600) / 60)).padStart(2, "0");
                // phoneTimeUsedSecond = String(Math.floor(phoneTimeUsed - phoneTimeUsedHour * 3600 - phoneTimeUsedMinute * 60)).padStart(2, "0");
              }
              let phoneTime = item["phone_package_order"]["phone_package_product"]["phone_package"]["included_total_phone_time"];
              let phoneTimeHour = "";
              let phoneTimeMinute = "";
              // let phoneTimeSecond = "";
              if(phoneTime === undefined || phoneTime === 0) {
                return '-';
              }
              else {
                phoneTimeHour = Math.floor(phoneTime / 3600);
                phoneTimeMinute = String(Math.floor((phoneTime - phoneTimeHour * 3600) / 60)).padStart(2, "0");
                // phoneTimeSecond = String(Math.floor(phoneTime - phoneTimeHour * 3600 - phoneTimeMinute * 60)).padStart(2, "0");
              }
              return `${phoneTimeUsedHour}h${phoneTimeUsedMinute} / ${phoneTimeHour}h${phoneTimeMinute !== "00"?phoneTimeMinute:""}`;
            }
          },
          {
            id: "callFranceLandline",
            label: "Appel france fixe",
            value: (item) => {
              let callQuantity = item["phone_package_order"]["monthly_consumption"]["total_call_quantity_france_landline"];
              if(callQuantity === undefined) {
                callQuantity = '-';
              }
              let callTime = item["phone_package_order"]["monthly_consumption"]["total_phone_time_france_landline"];
              let callTimeHour = "";
              let callTimeMinute = "";
              // let callTimeSecond = "";
              if(callTime !== undefined) {
                callTimeHour = Math.floor(callTime / 3600);
                callTimeMinute = String(Math.floor((callTime - callTimeHour * 3600) / 60)).padStart(2, "0");
                // callTimeSecond = String(Math.floor(callTime - callTimeHour * 3600 - callTimeMinute * 60)).padStart(2, "0");
              }
              return `${callQuantity} / ${callTime === undefined?"-":`${callTimeHour}h${callTimeMinute}`}`
            }
          },
          {
            id: "callFranceMobile",
            label: "Appel france mobile",
            value: (item) => {
              let callQuantity = item["phone_package_order"]["monthly_consumption"]["total_call_quantity_france_mobile"];
              if(callQuantity === undefined) {
                callQuantity = '-';
              }
              let callTime = item["phone_package_order"]["monthly_consumption"]["total_phone_time_france_mobile"];
              let callTimeHour = "";
              let callTimeMinute = "";
              // let callTimeSecond = "";
              if(callTime !== undefined) {
                callTimeHour = Math.floor(callTime / 3600);
                callTimeMinute = String(Math.floor((callTime - callTimeHour * 3600) / 60)).padStart(2, "0");
                // callTimeSecond = String(Math.floor(callTime - callTimeHour * 3600 - callTimeMinute * 60)).padStart(2, "0");
              }
              return `${callQuantity} / ${callTime === undefined?"-":`${callTimeHour}h${callTimeMinute}`}`
            }
          },
          {
            id: "callInternational",
            label: "Appel international",
            value: (item) => {
              let callQuantity = item["phone_package_order"]["monthly_consumption"]["total_call_quantity_international"];
              if(callQuantity === undefined) {
                callQuantity = '-';
              }
              let callTime = item["phone_package_order"]["monthly_consumption"]["total_phone_time_international"];
              let callTimeHour = "";
              let callTimeMinute = "";
              // let callTimeSecond = "";
              if(callTime !== undefined) {
                callTimeHour = Math.floor(callTime / 3600);
                callTimeMinute = String(Math.floor((callTime - callTimeHour * 3600) / 60)).padStart(2, "0");
                // callTimeSecond = String(Math.floor(callTime - callTimeHour * 3600 - callTimeMinute * 60)).padStart(2, "0");
              }
              return `${callQuantity} / ${callTime === undefined?"-":`${callTimeHour}h${callTimeMinute}`}`
            }
          },
          {
            id: "callSpecialNumber",
            label: "Appel num. spéciaux",
            value: (item) => {
              let callQuantity = item["phone_package_order"]["monthly_consumption"]["total_call_quantity_special_number"];
              if(callQuantity === undefined) {
                callQuantity = '-';
              }
              let callTime = item["phone_package_order"]["monthly_consumption"]["total_phone_time_special_number"];
              let callTimeHour = "";
              let callTimeMinute = "";
              // let callTimeSecond = "";
              if(callTime !== undefined) {
                callTimeHour = Math.floor(callTime / 3600);
                callTimeMinute = String(Math.floor((callTime - callTimeHour * 3600) / 60)).padStart(2, "0");
                // callTimeSecond = String(Math.floor(callTime - callTimeHour * 3600 - callTimeMinute * 60)).padStart(2, "0");
              }
              return `${callQuantity} / ${callTime === undefined?"-":`${callTimeHour}h${callTimeMinute}`}`
            }
          },
        ]
      },
    },

    sizing: {
      numberColumn: 2,
      formSizeMd: 12
    },
  }
}
